/**
 * Constants
 */
export const USER_REGISTERED = 'UserRegistered'
export const USER_DELETED = 'UserDeleted'
export const TASK_CREATED = 'TaskCreated'
export const TASK_ALLOCATED = 'TaskAllocated'
export const TASK_ACCEPTED = 'TaskAccepted'
export const TASK_REJECTED = 'TaskRejected'
export const TASK_DELETED = 'TaskDeleted'
export const REJECTER_DELETED = 'RejecterDeleted'
